"use client";
import { useDotButton } from "../../design1/components/Testimonials";
import React, { useCallback, useEffect, useState } from "react";
import Pagination from "./Pagination";
import useEmblaCarousel from "embla-carousel-react";
import VideoPlayer from "../../design1/components/VideoComponent";
import BackBtn from "./BackBtn3";
import { FaTimes } from "react-icons/fa";
import Image from "next/image";

export interface SliderImagesProps {
  url: string;
  type: "image" | "video";
}

export function generateSliderImages(
  imageUrls: string[],
  videoUrls: string[] = []
): SliderImagesProps[] {
  const imageArray: SliderImagesProps[] = imageUrls.map((url) => ({
    url,
    type: "image",
  }));

  const videoArray: SliderImagesProps[] = videoUrls.map((url) => ({
    url,
    type: "video",
  }));

  return [...imageArray, ...videoArray];
}

const PropertyCarousel2: React.FC<{ images: SliderImagesProps[] }> = ({
  images,
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
  });
  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on("select", onSelect);
    onSelect();
  }, [emblaApi, onSelect]);

  const [open, setOpen] = useState(false);
  return (
    <>
      <section
        onClick={() => {
          setOpen(false);
        }}
        className={`pb-10 w-full z-[100] ${
          open && "bg-black/90 pt-6  fixed top-0 bottom-0 h-full "
        } max-w-full overflow-hidden`}
      >
        {open && (
          <span
            onClick={() => {
              setOpen(false);
            }}
            className="absolute cursor-pointer z-[100] top-3 left-3"
          >
            <FaTimes size={25} color="white" />
          </span>
        )}

        <div
          className={` relative   my-auto ${
            open && "!top-1/2 !-translate-y-1/2"
          }  top-4 left-4`}
        >
          <div className="relative 0  ">
            <div
              onClick={(e) => {
                e.stopPropagation();
                if (emblaApi) {
                  emblaApi.scrollNext();
                }
              }}
              className="prev z-[20] top-1/2  sm:-left-1 -translate-y-1/2 absolute left-8 transform rotate-[180deg]"
            >
              <NavigateIconVariant />
            </div>
            <div
              onClick={(e) => {
                e.stopPropagation();
                if (emblaApi) {
                  emblaApi.scrollPrev();
                }
              }}
              className="next absolute top-1/2 z-[20]  sm:right-5 -translate-y-1/2 right-12"
            >
              <NavigateIconVariant />
            </div>
            <div
              className={`item wrapper ${open && "overflow-hidden"} relative`}
            >
              {!open && (
                <span className="absolute z-[20] top-6 left-6 ">
                  <BackBtn />
                </span>
              )}

              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                ref={emblaRef}
                className="items  gap-4 "
              >
                <div className="flex my-auto h-max">
                  {images.map((item, index) => {
                    return (
                      <div
                        onClick={() => {
                          if (emblaApi) {
                            emblaApi.scrollTo(index);
                          }
                          setOpen(true);
                        }}
                        key={index}
                        className={` w-[70%] overflow-hidden rounded-xl min-w-[400px] max-h-[600px] pr-8 select-none flex justify-center ${
                          open && "!w-full sm:max-h-[60vh] !max-h-[90vh]"
                        } shrink-0`}
                      >
                        {item.type === "image" ? (
                          <div className="w-full h-full">
                            <Image
                              height={1000}
                              width={1000}
                              className="h-full rounded-xl object-cover w-full"
                              src={item.url}
                              alt="Property Image"
                            />
                          </div>
                        ) : (
                          item.type === "video" &&
                          item.url && <VideoPlayer url={item.url} />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          {!open && (
            <div className="pagination mt-5">
              <Pagination
                scrollSnaps={scrollSnaps}
                selectedIndex={selectedIndex}
                onDotButtonClick={onDotButtonClick}
                emblaApi={emblaApi}
              />
            </div>
          )}
        </div>
      </section>
    </>
  );
};
export default PropertyCarousel2;

export const NavigateIconVariant = () => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="30"
          cy="30"
          r="30"
          transform="matrix(-1 0 0 1 60 0)"
          fill={
            hovered
              ? "var(--primary-color)"
              : "rgba(var(--primary-color-rgb), 0.4)"
          }
        />
        <path
          d="M23.418 17.5294C23.2827 17.3863 23.177 17.2179 23.1068 17.0339C23.0366 16.8499 23.0034 16.6539 23.009 16.4571C23.0145 16.2603 23.0588 16.0664 23.1393 15.8867C23.2197 15.707 23.3348 15.5449 23.478 15.4096C23.6211 15.2744 23.7894 15.1687 23.9734 15.0985C24.1574 15.0283 24.3534 14.995 24.5502 15.0006C24.7471 15.0062 24.9409 15.0505 25.1206 15.1309C25.3003 15.2114 25.4625 15.3265 25.5977 15.4696L38.3402 28.9617C38.6034 29.24 38.75 29.6085 38.75 29.9916C38.75 30.3746 38.6034 30.7431 38.3402 31.0215L25.5977 44.515C25.4634 44.6613 25.3013 44.7794 25.1209 44.8625C24.9405 44.9456 24.7454 44.992 24.5469 44.9991C24.3485 45.0061 24.1506 44.9736 23.9647 44.9036C23.7789 44.8335 23.6089 44.7272 23.4645 44.5908C23.3201 44.4545 23.2042 44.2908 23.1236 44.1093C23.043 43.9278 22.9993 43.7321 22.9949 43.5335C22.9906 43.335 23.0258 43.1375 23.0984 42.9527C23.171 42.7678 23.2797 42.5993 23.418 42.4568L35.1891 29.9916L23.418 17.5294Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
